import { useEffect } from "react";

const DEFAULT_TITLE = "FarmTopia — Smart Farm Management for Egyptian Farms";

/**
 * Per-route document title + meta description for the marketing SPA.
 *
 * This is the client-rendered MVP: Googlebot executes JS and will pick up
 * the updated title/description. Full prerendering of these routes
 * (react-snap or SSG) is the Phase 3 SEO hardening tracked in
 * LANDING_PAGE_V2_ARCHITECTURE.md — until then, social-share crawlers that
 * do not execute JS see the static index.html metadata.
 */
export default function useDocumentMeta({ title, description } = {}) {
  useEffect(() => {
    const previousTitle = document.title;
    if (title) document.title = title;

    let descTag = null;
    let previousDesc = null;
    if (description) {
      descTag = document.querySelector('meta[name="description"]');
      if (!descTag) {
        descTag = document.createElement("meta");
        descTag.setAttribute("name", "description");
        document.head.appendChild(descTag);
      }
      previousDesc = descTag.getAttribute("content");
      descTag.setAttribute("content", description);
    }

    return () => {
      document.title = previousTitle || DEFAULT_TITLE;
      if (descTag && previousDesc !== null) {
        descTag.setAttribute("content", previousDesc);
      }
    };
  }, [title, description]);
}
